import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";

pdfMake.vfs = pdfFonts;
